import { useEffect, useRef } from "react";

/**
 * Slot iklan Google AdSense.
 * Aktif otomatis bila VITE_ADSENSE_CLIENT (mis. "ca-pub-1234567890123456") diisi.
 * Tanpa konfigurasi, slot tidak ditampilkan di produksi.
 */
export const adsenseClient = (import.meta.env["VITE_ADSENSE_CLIENT"] as string | undefined)?.trim() ?? "";

export function AdSlot({
  slot,
  format = "auto",
  className,
  label = "Iklan",
}: {
  slot?: string;
  format?: "auto" | "fluid" | "horizontal" | "rectangle";
  className?: string;
  label?: string;
}) {
  const ref = useRef<HTMLModElement>(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (!adsenseClient || pushed.current || !ref.current) return;
    pushed.current = true;
    try {
      const w = window as unknown as { adsbygoogle?: unknown[] };
      w.adsbygoogle = w.adsbygoogle ?? [];
      w.adsbygoogle.push({});
    } catch (e) {
      console.error("[ads] gagal memuat slot", e);
    }
  }, []);

  if (!adsenseClient) {
    if (!import.meta.env.DEV) return null;
    return (
      <div
        className={`grid min-h-24 place-items-center rounded-xl border border-dashed border-border/70 bg-muted/30 text-[11px] uppercase tracking-wide text-muted-foreground ${className ?? ""}`}
      >
        Slot iklan (atur VITE_ADSENSE_CLIENT)
      </div>
    );
  }

  return (
    <div className={className}>
      <p className="mb-1 text-[10px] uppercase tracking-wide text-muted-foreground">{label}</p>
      <ins
        ref={ref}
        className="adsbygoogle block"
        style={{ display: "block" }}
        data-ad-client={adsenseClient}
        {...(slot ? { "data-ad-slot": slot } : {})}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}
